// extracted by mini-css-extract-plugin
export var tosLink = "_dz-0";